import {PanelLeftFilledIcon} from 'src/layouts/main-layout/app-sidebar/icons/panel-left-filled.icon'
import {PanelLeftIcon} from 'src/layouts/main-layout/app-sidebar/icons/panel-left.icon'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'
import {useAppSidebar} from './app-sidebar-context'

export function AppSidebarCollapseButton() {
  const {collapsed, toggleCollapsed, isCompanieSelectorCollapsed} = useAppSidebar()

  return (
    <button
      type='button'
      onClick={toggleCollapsed}
      data-slot='sidebar-collapse-button'
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-lg',
        'transition-all duration-300 ease-in-out',
        'hover:bg-primary/60',
        'focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none',
        collapsed && 'mx-auto',
        isCompanieSelectorCollapsed ? 'pointer-events-none absolute h-0 w-0 scale-95 opacity-0' : 'scale-100 opacity-100',
      )}>
      {collapsed ? <PanelLeftFilledIcon /> : <PanelLeftIcon />}
    </button>
  )
}
